import { maintenanceStatus } from "./placeMaintenance";

export function getSourceAttribute(record, key) {
  const attribute = record?.attributes?.[key];
  if (["needs-review", "stale"].includes(maintenanceStatus(attribute)))
    return null;
  if (!["high", "medium"].includes(attribute?.confidence)) return null;
  if (
    !attribute.value ||
    ["unknown", "n/a"].includes(String(attribute.value).toLowerCase())
  )
    return null;
  try {
    const url = new URL(attribute.source);
    return ["https:", "http:"].includes(url.protocol) ? attribute : null;
  } catch {
    return null;
  }
}
